import "../namespaces";
import { delegate } from "../../exports/event";
import { eventLoader } from "../../exports/event-loader";

/**
 *
 */
eventLoader.onLoad(100, () => {
  delegate(document as never, "click", ".js_goBack", function goBack(e) {
    const url = this.getAttribute("href");

    e.preventDefault();
    window.history.back();

    if (url) {
      setTimeout(() => {
        window.location = url as never;
      }, 200);
    }
  });
});
